export { ReactComponent as cupIcon } from './cup.svg';
